module.exports = __webpack_public_path__ + "static/media/sghrm.cb83f8aa.jpg";